import React from "react"
import { Link } from "react-router-dom"
import Background from "../../../../assets/images/anynomus-backgroud.png"
import Logo from "../../../../assets/images/logo.png"
import { ROUTE_PATHS } from "../../../../constants/url-config"
import "./anonymous.scss"
import i18n from "../../../../utils/i18n"

const AnonymousLayout = ({ children }: any) => {

	React.useEffect(() => {
		window.scrollTo(0, 0)
	}, [children])

	return (
		<div className="default-layout">
			<div className='left-bar-wrapper' style={{ backgroundImage: `url(${Background})` }}>
				<div className='left-bar-content'>
					<Link to={ROUTE_PATHS.SignIn}>
						<img className='logo' src={Logo} alt='Logo' />
					</Link>
					<div className="copy-rights">&copy; 2024 BBA. {i18n.t("Menu.allRightsReserved")}.</div>
				</div>

			</div>

			<div className="main-content">
				<div className='content-box'>
					{children}
				</div>
			</div>
		</div>
	)
}

export default AnonymousLayout
